import { SERVER_API, responseData } from './BaseApi';


export const loginApi = (data: {
  account: string;
  password: string;
}) => {
  return SERVER_API.post<responseData, responseData>(`v1/auth/login`, data);
};

export const uploadFileApi = (data: {
  file: any;
  type: string;
}) => {
  const fmData = new FormData();
  fmData.append("file", data.file);
  fmData.append("type", data.type);
  return SERVER_API.post<responseData, responseData>(`v1/file/upload`, fmData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const getBannersApi = (data: {
  page: number;
  per_page: number;
}) => {
  return SERVER_API?.get<responseData, responseData>(
    `v1/manage/banners?page=${data.page}&per_page=${data.per_page}`
  )
}

export const updateBannerApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/banner/update`, data)
}

export const createBannerApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/banner/create`, data)
}

export const deleteBannerApi = (id: number) => {
  return SERVER_API?.delete<responseData, responseData>(`v1/manage/banner/delete`, { params: {id: id} })
}

export const getAllMenuApi = () => {
  return SERVER_API?.get<responseData, responseData>(`v1/manage/menu`)
}

export const updateCategoryApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/category/update`, data)
}

export const createCategoryApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/category/create`, data)
}

export const deleteCategoryApi = (id: number) => {
  return SERVER_API?.delete<responseData, responseData>(`v1/manage/category/delete`, { params: {id: id} })
}

export const getAllCategoryListApi = () => {
  return SERVER_API?.get<responseData, responseData>(`v1/manage/categories`)
}

export const getArticlesApi = (data: {
  page: number;
  per_page: number;
  category_id?: number;
}) => {
  return SERVER_API?.get<responseData, responseData>(
    `v1/manage/articles?page=${data.page}&per_page=${data.per_page}&category_id=${data.category_id || ''}`
  )
}

export const getArticleApi = (id: number) => {
  return SERVER_API?.get<responseData, responseData>(
    `v1/manage/article/info?id=${id}`
  )
}

export const updateArticleApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/article/update`, data)
}

export const createArticleApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/article/create`, data)
}

export const deleteArticleApi = (id: number) => {
  return SERVER_API?.delete<responseData, responseData>(`v1/manage/article/delete`, { params: {id: id} })
}

export const getArticleAboutApi = () => {
  return SERVER_API?.get<responseData, responseData>(
    `v1/manage/article/about`
  )
}

export const updateArticleAboutApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/article/about/update`, data)
}

export const getArticleContactApi = () => {
  return SERVER_API?.get<responseData, responseData>(
    `v1/manage/article/contact`
  )
}

export const updateArticleContactApi = (data: any) => {
  return SERVER_API?.post<responseData, responseData>(`v1/manage/article/contact/update`, data)
}